import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import AccountBalanceFilters from "./components/AccountBalanceFilters";
import AccountBalanceTable from "./components/AccountBalanceTable";
import { fetchAccountBalance } from "./AccountBalanceThunk";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportAccountBalanceCsv } from "./components/exportAccountBalanceCsv";

const { Title } = Typography;

const AccountBalance = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
 const { filters, list, totals } = useSelector((state) => state.accountBalance);

  useEffect(() => {
    dispatch(fetchAccountBalance({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Cash & Bank Balance Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportAccountBalanceCsv({
      list,
      totals,
      title:    "Cash & Bank Balance Report",
      filename: "cash_bank_balance",
    });
  };

  const hasData = list.length > 0;

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >
              Cash & Bank Balance Report
            </Title>
          }
           extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <AccountBalanceFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <AccountBalanceTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Cash & Bank Balance Report"
          filters={filters}
          renderTable={() => (
            <AccountBalanceTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default AccountBalance;
